module.exports = __webpack_public_path__ + "static/media/modal-tags.367614c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FAQ/assets/modal-tags.png
// module id = 924
// module chunks = 0